var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pb-5 sm:flex sm:items-center sm:justify-between mb-10"},[_c('h1',{staticClass:"text-gray-800 text-3xl tracking-widest"},[_vm._v("\n            "+_vm._s(_vm.headline)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"mt-3 flex sm:mt-0 sm:ml-4"},[_vm._t("action")],2)]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }